import { dropdownEllipsisWidth } from "ds/components/DropdownMenu/constants";
import { Spacing } from "types/Spacing";
import { SearchQueryOrderDirection } from "types/generated";

export const COLUMN_GAP: Spacing = "large";
export const COLUMN_ORDER = `minmax(5rem, 4fr) minmax(2rem, 0.5fr)  ${dropdownEllipsisWidth}`;

export const FILTERS_TYPE = "policySamples";
export const FILTERS_ORDER_SETTINGS_KEY = "policySamplesFiltersOrder";

export enum FilterItemKeys {
  CREATED_AT = "createdAt",
  OUTCOME = "outcome",
  COMMIT_AUTHOR = "commitAuthor",
  DRIFT_DETECTION = "driftDetection",
  MODULE_NAME = "moduleName",
  MODULE_VERSION = "moduleVersion",
  REQUEST_COMMAND = "requestCommand",
  RUN_TYPE = "runType",
  RUN_BRANCH = "runBranch",
  RUN_DRIFT_DETECTION = "runDriftDetection",
  STACK_NAME = "stackName",
  STACK_REPOSITORY = "stackRepository",
  PULL_REQUEST_ACTION = "pullRequestAction",
  PULL_REQUEST_AUTHOR = "pullRequestAuthor",
  PULL_REQUEST_ID = "pullRequestId",
  PUSH_BRANCH = "pushBranch",
  PUSH_HASH = "pushHash",
  VCS_INTEGRATION_NAME = "vcsIntegrationName",
  SESSION_LOGIN = "sessionLogin",
  SESSION_NAME = "sessionName",
}

export const FILTER_ITEMS_DICTIONARY: Partial<Record<FilterItemKeys, string>> = {
  [FilterItemKeys.CREATED_AT]: "Created at",
  [FilterItemKeys.OUTCOME]: "outcome",
  [FilterItemKeys.COMMIT_AUTHOR]: "commit author",
  [FilterItemKeys.DRIFT_DETECTION]: "drift detection",
  [FilterItemKeys.MODULE_NAME]: "module name",
  [FilterItemKeys.MODULE_VERSION]: "module version",
  [FilterItemKeys.REQUEST_COMMAND]: "request command",
  [FilterItemKeys.RUN_TYPE]: "run type",
  [FilterItemKeys.RUN_BRANCH]: "run branch",
  [FilterItemKeys.RUN_DRIFT_DETECTION]: "run drift detection",
  [FilterItemKeys.STACK_NAME]: "stack name",
  [FilterItemKeys.STACK_REPOSITORY]: "stack repository",
  [FilterItemKeys.PULL_REQUEST_ACTION]: "pull request action",
  [FilterItemKeys.PULL_REQUEST_AUTHOR]: "pull request author",
  [FilterItemKeys.PULL_REQUEST_ID]: "pull request ID",
  [FilterItemKeys.PUSH_BRANCH]: "push branch",
  [FilterItemKeys.VCS_INTEGRATION_NAME]: "vCS integration name",
  [FilterItemKeys.SESSION_LOGIN]: "session login",
  [FilterItemKeys.SESSION_NAME]: "session name",
};

export const INITIAL_SORT_OPTION = FilterItemKeys.CREATED_AT;
export const INITIAL_SORT_DIRECTION = SearchQueryOrderDirection.Desc;

export const ENTITIES_PER_PAGE = 50;

export const POLICIES_LIST_ITEM_TEST_ID = "policies-samples-list-item";
